var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"lds-dual-ring",style:(`
        width: ${_vm.size}px; 
        height: ${_vm.size}px;
        border-color: ${_vm.color} transparent ${_vm.color} transparent;
      `)})]),(_vm.label != '')?_c('div',{staticClass:"label",style:(`color: ${_vm.color};`)},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }